/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateFboLocationRequestDto } from '../../models/create-fbo-location-request-dto';
import { FboLocationResponse } from '../../models/fbo-location-response';

export interface CreateFboLocation$Params {
      body: CreateFboLocationRequestDto
}

export function createFboLocation(http: HttpClient, rootUrl: string, params: CreateFboLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationResponse>> {
  const rb = new RequestBuilder(rootUrl, createFboLocation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationResponse>;
    })
  );
}

createFboLocation.PATH = '/api/administration/fbo-locations';
